<div class="header">
    <strong>NOME</strong>
    <strong>CNPJ</strong>
    <strong>DATA DE CRIAÇÃO</strong>
    <strong>STATUS</strong>
    <strong *ngIf="hasSupervisorRole">AÇÕES</strong>
  </div>
  